import { Panel } from "components/ui/panel/panel";
import { PanelType } from "components/ui/panel/panel-type";
import { useTaskNouns } from "hooks/use-task-nouns";
import React from "react";
import { TaskCalendarDto } from "./calendar-types";
import { formatSidebarDate, formatTime, parseDateTimeToTimeStr } from "./calendar-utils";

interface TaskDetailPanelProps {
    task: TaskCalendarDto;
    onClose: () => void;
}

export const TaskDetailPanel: React.FC<TaskDetailPanelProps> = ({ task, onClose }) => {
    const nouns = useTaskNouns();
    const timeStr = task.dueDateTime ? parseDateTimeToTimeStr(task.dueDateTime) : null;

    const dateStr = task.dueDate
        ? formatSidebarDate(task.dueDate)
        : task.dueDateTime
          ? formatSidebarDate(task.dueDateTime.split("T")[0])
          : null;

    return (
        <Panel
            isOpen={true}
            type={PanelType.medium}
            headerText={nouns.titleSingular}
            onDismiss={onClose}>
            <div className="p-4 space-y-4">
                {task.text ? (
                    <div>
                        <h3 className="text-sm font-medium text-gray-500">Description</h3>
                        <p className="mt-1 text-sm text-gray-900">{task.text}</p>
                    </div>
                ) : null}
                {dateStr ? (
                    <div>
                        <h3 className="text-sm font-medium text-gray-500">Due</h3>
                        <p className="mt-1 text-sm text-gray-900">
                            {dateStr}
                            {timeStr ? ` at ${formatTime(timeStr)}` : ""}
                        </p>
                    </div>
                ) : null}
                <div>
                    <h3 className="text-sm font-medium text-gray-500">Status</h3>
                    <p className="mt-1 text-sm text-gray-900 capitalize">{task.status}</p>
                </div>
                <div className="pt-2">
                    <a
                        href={`/tasks/${task.id}`}
                        className="text-sm text-brand-600 hover:text-brand-700 font-medium">
                        View full task
                    </a>
                </div>
            </div>
        </Panel>
    );
};
